import * as React from 'react';

import { BoxProps } from '@mui/system';
import { Box, Radio, RadioProps } from '@mui/material';

import { CerebroLabel } from '.';

const Context = React.createContext<CerebroRadioGroupContext | null>(null);

export const CerebroRadioGroup: React.FC<CerebroRadioGroupProps> = ({
	name,
	error,
	value,
	onChange,
	children,
	...props
}) => {
	const context: CerebroRadioGroupContext = {
		name,
		error,
		selectedValue: value,
		onSelectedValueChange: newSelectedValue => onChange({ target: { name, value: newSelectedValue } }),
	};

	return (
		<Context.Provider value={context}>
			<Box {...props}>{children}</Box>
		</Context.Provider>
	);
};
function useCerebroRadioGroup() {
	var context = React.useContext(Context);

	if (context == null) throw Error('You tried to use an <CerebroRadioButton/> outside of an <CerebroRadioGroup/>!');

	return context;
}

export const CerebroRadioButton: React.FC<CerebroRadioButtonProps> = ({ size, value, children, ...props }) => {
	const { name, error, selectedValue, onSelectedValueChange } = useCerebroRadioGroup();

	const selected = selectedValue == value;
	const onChange = () => onSelectedValueChange(value);

	return (
		<CerebroLabel size={size == 'small' ? 'small' : 'large'}>
			<Radio size={size} name={name} checked={selected} onChange={onChange} {...props} /> {children}
		</CerebroLabel>
	);
	// name={name} error={error} value={selected} onChange={onChange} {...props} />;
};

// Like a partial React.ChangeEvent because formik falls back to handling any value it receives on change as an event if it isn't a string.
export interface CerebroRadioGroupChangeEvent {
	target: {
		name: string;
		value: string;
	};
}

interface CerebroRadioGroupProps extends Omit<BoxProps, 'onChange'> {
	name: string;
	value: string;
	error: boolean;
	onChange: (event: CerebroRadioGroupChangeEvent) => void;
	sx: BoxProps['sx'];
}

interface CerebroRadioGroupContext {
	name: string;
	error: boolean;
	selectedValue: string;
	onSelectedValueChange: (newSelectedValue: string) => void;
}

type CerebroRadioButtonProps = Omit<RadioProps, 'value' | 'onChange' | 'name' | 'error'> & {
	value: string;
};
